import React, { useState } from "react";
import T from '../../components/common/T';
import api from "../../api/axiosConfig";
import Price from "../../components/common/Price";
import { toast } from "react-toastify";
import { XMarkIcon, BanknotesIcon } from "@heroicons/react/24/outline";

export default function RecordBillPaymentModal({ isOpen, onClose, bill, onSuccess }) {
  const [formData, setFormData] = useState({
    paymentDate: new Date().toISOString().split('T')[0],
    amount: bill.balance_due || "", // Default to full balance
    method: "bank_transfer",
    reference: "",
    notes: ""
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/accounting/bills/pay', {
        billId: bill.id,
        ...formData
      });

      toast.success("Payment Recorded!");
      onSuccess(); // Refresh parent data
      onClose();
    } catch (err) {
      console.error(err);
      toast.error("Payment Failed");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-white dark:bg-[#161b22] rounded-xl shadow-2xl w-full max-w-md overflow-hidden border border-gray-200 dark:border-[#30363d] transition-colors">
        
        <div className="bg-gray-50 dark:bg-[#21262d] px-6 py-4 border-b border-gray-200 dark:border-[#30363d] flex justify-between items-center">
            <h2 className="font-bold text-gray-800 dark:text-white flex items-center gap-2">
                <BanknotesIcon className="w-5 h-5 text-green-500" /> 
                Record Payment
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-red-500 transition"><XMarkIcon className="w-5 h-5" /></button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <div className="bg-blue-50 dark:bg-blue-950/40 p-3 rounded-lg border border-blue-100 dark:border-blue-900/50 flex justify-between items-center">
                <span className="text-sm text-blue-700 dark:text-blue-300 font-medium"><T>Balance Due:</T></span>
                <span className="text-lg font-bold text-blue-900 dark:text-blue-200"><Price amount={Number(bill.balance_due)} /></span>
            </div>

            <div>
                <label className="block text-xs font-bold text-gray-500 dark:text-slate-400 uppercase"><T>Amount (₹)</T></label>
                <input 
                  type="number" required max={bill.balance_due}
                  className="w-full border border-gray-300 dark:border-[#30363d] bg-white dark:bg-[#21262d] rounded-lg p-2.5 mt-1 font-bold text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500 outline-none"
                  value={formData.amount}
                  onChange={e => setFormData({...formData, amount: e.target.value})}
                />
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-xs font-bold text-gray-500 dark:text-slate-400 uppercase"><T>Date</T></label>
                    <input type="date" required className="w-full border border-gray-300 dark:border-[#30363d] bg-white dark:bg-[#21262d] rounded-lg p-2.5 mt-1 text-sm text-gray-900 dark:text-white" 
                        value={formData.paymentDate} onChange={e => setFormData({...formData, paymentDate: e.target.value})} />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-500 dark:text-slate-400 uppercase"><T>Method</T></label>
                    <select className="w-full border border-gray-300 dark:border-[#30363d] rounded-lg p-2.5 mt-1 text-sm bg-white dark:bg-[#21262d] text-gray-900 dark:text-white" 
                        value={formData.method} onChange={e => setFormData({...formData, method: e.target.value})}>
                        <option value="bank_transfer"><T>Bank Transfer</T></option>
                        <option value="check"><T>Cheque</T></option>
                        <option value="cash"><T>Cash</T></option>
                        <option value="upi"><T>UPI / Online</T></option>
                    </select>
                </div>
            </div>

            <div>
                <label className="block text-xs font-bold text-gray-500 dark:text-slate-400 uppercase"><T>Reference #</T></label>
                <input type="text" className="w-full border border-gray-300 dark:border-[#30363d] bg-white dark:bg-[#21262d] text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-slate-500 rounded-lg p-2.5 mt-1 text-sm" 
                   placeholder="e.g. Transaction ID"
                   value={formData.reference} onChange={e => setFormData({...formData, reference: e.target.value})} />
            </div>

            <div className="flex justify-end gap-3 pt-2">
                <button type="button" onClick={onClose} className="px-4 py-2 text-gray-500 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg font-medium"><T>Cancel</T></button>
                <button type="submit" disabled={loading} className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-bold shadow-md transition disabled:opacity-50">
                    {loading ? "Processing..." : "Confirm Payment"}
                </button>
            </div>
        </form>
      </div>
    </div>
  );
}